module.exports = __webpack_public_path__ + "static/corner-banner-0f3404a6b523d1128fc9e5e0c647838e.png";